module.exports = __webpack_public_path__ + "img/security-audit-img-3.0f07c391.png";